<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="size"
    :height="size"
    viewBox="0 0 21 21"
    fill="none"
    class="pencil-icon"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      :stroke="color"
      stroke-linejoin="round"
      d="M14.962 0.793027 C15.3523 0.402478 15.9853 0.402213 16.376 0.792434 L19.7923
      4.20489 C20.1831 4.59527 20.1834 5.2286 19.7929 5.61931 L6.7667 18.6526 C6.62742
      18.7919 6.45008 18.887 6.25693 18.926 L0.5 20.0859 L1.66204 14.336 C1.701
      14.1432 1.79591 13.9662 1.93493 13.8271 L14.962 0.793027 Z"
    />
  </svg>
</template>

<script>
export default {
  name: 'PencilIcon',
  props: {
    size: {
      type: [Number, String],
      default: '100%',
    },
    color: {
      type: String,
      default: '#7F7F7F',
    },
  },
  data() {
    return {
      // eslint-disable-next-line max-len
      pathData: 'M14.962 0.793027C15.3523 0.402478 15.9853 0.402213 16.376 0.792434L19.7923 4.20489C20.1831 4.59527 20.1834 5.2286 19.7929 5.61931L6.7667 18.6526C6.62742 18.7919 6.45008 18.887 6.25693 18.926L0.5 20.0859L1.66204 14.336C1.701 14.1432 1.79591 13.9662 1.93493 13.8271L14.962 0.793027Z',
    };
  },
};
</script>

<style scoped>
.pencil-icon {
  display: inline-block;
  vertical-align: middle;
  flex-shrink: 0;
}
</style>
